import { useEffect, useState } from "react";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Box, Button, Container, TextField, Autocomplete, Switch, Typography, CircularProgress } from "@mui/material";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { CustomNumberInput, Modal } from '../../components';
import CategoriaService from '../../services/categorias';
import ImagenesService from '../../services/imagenes';
import UploadImage from "../UploadImage";
import { Root } from '../../styles';
import { FormPrecio } from "../FormPrecio";

const formSchema = Yup.object().shape({
  quantity_in_stock: Yup.number().required("Campo Requerido"),
  quantity_sold: Yup.number().required("Campo Requerido").moreThan(0).max(Yup.ref('quantity_in_stock'), 'Debe ser menor a la cantidad disponible'),
  prices_sold: Yup.object().shape({
    sale_price: Yup.number().required('Campo Requerido').moreThan(0),
  }),
  prices: Yup.object().shape({
    list_price: Yup.number().required('Campo Requerido').moreThan(0),
    sale_price: Yup.number().required('Campo Requerido').moreThan(0),
  })
})

const FormVenta = ({ article, onClose, onSubmit, saving = false }) => {
  const { quantity } = article;

  let initialValues = {
    quantity_in_stock: quantity,
    quantity_sold: 1,
    prices_sold: {
      list_price: article?.prices?.list_price,
      sale_price: article?.prices?.sale_price
    },
    prices: {
      list_price: article?.prices?.list_price,
      sale_price: article?.prices?.sale_price
    }
  }

  const handleSubmitForm = async (data) => {
    console.log(data)
    console.log("Submit")

    if (onSubmit) {
      onSubmit(data)
    }
  }

  const { handleChange, handleSubmit, setFieldValue, values, errors, isValid } = useFormik({
    initialValues,
    onSubmit: handleSubmitForm,
    validationSchema: formSchema,
  })

  const { quantity_in_stock, prices, quantity_sold, prices_sold } = values

  return <>
    <Box
      component="form"
      onSubmit={handleSubmit}
      padding={3}
    >
      <strong>{saving ? 'Guardado venta' : 'Vender Articulo'}</strong>
      {saving ? <Box display='flex' justifyContent='center' paddingTop={3}>
        <CircularProgress color="secondary" />
      </Box> :
        <Box>
          <Box display='flex' flexDirection='row' gap={2} marginY={1}>
            <TextField
              id="prices.sale_price"
              label="Precio Venta"
              type="text"
              variant="standard"
              // sx={{ mt: 2, margin: 'auto' }}
              fullWidth
              // error={errors.name}
              // helperText={errors.name}
              //name="name"
              value={prices.sale_price}
              disabled
            />
            <TextField
              id="quantity_in_stock"
              label="En stock"
              type="text"
              variant="standard"
              // sx={{ mt: 2, margin: 'auto' }}
              fullWidth
              // error={errors.name}
              // helperText={errors.name}
              //name="name"
              value={quantity_in_stock}
              disabled
            />
          </Box>
          <Box display='flex' flexDirection='row' alignItems='flex-end' gap={2} marginY={1}>
            <CustomNumberInput
              symbol
              labelText='Precio '
              value={prices_sold?.sale_price}
              line={false}
              //onChange={handleChange}
              onChange={(event, newValue) => {
                event.preventDefault();
                setFieldValue('prices_sold.sale_price', newValue);
                // onChange('prices.sale_price', newValue);
              }}
            />
            <CustomNumberInput
              id="quantity_sold"
              label='Venta'
              minimo={0}
              maximo={200}
              error={errors.quantity_sold}
              helperText={errors.quantity_sold}
              value={quantity_sold}
              //onChange={handleChange}
              onChange={(event, newValue) => {
                event.preventDefault();
                setFieldValue('quantity_sold', newValue);
              }}
              incrementsButtons
            />
          </Box>
          <Typography variant="h6" color="text.secondary">
            Esta Venta: ${prices_sold?.sale_price * quantity_sold}
          </Typography>
        </Box>}
      <Box sx={{ mt: 5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Button
          type="submit"
          variant="outlined"
          onClick={onClose}
          disabled={saving}
        >Cancelar</Button>
        <Button
          type="submit"
          variant="outlined"
          disabled={!isValid || saving}
          endIcon={
            <ShoppingCartIcon />
          }
        >Agregar </Button>
      </Box>
    </Box>
  </>
}

export default FormVenta;